angular.module('zc.core')
  .config(translations);

// Support for i18n
translations.$inject = ['$translateProvider'];
function translations($translateProvider) {
  $translateProvider.useStaticFilesLoader({
    prefix: '/assets/i18n/',
    suffix: '.json',
  }).registerAvailableLanguageKeys(['en', 'ja'], {
    'en_*': 'en',
    'ja_*': 'ja',
    '*': 'en'
  })
    .determinePreferredLanguage()
    // https://angular-translate.github.io/docs/#/guide/19_security
    .useSanitizeValueStrategy('sceParameters');
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/config/zc.core.translations.js